module.exports = __webpack_public_path__ + "img/el-salvador.02e6f0d9.svg";